// Frontend mirror of backend RBAC. Owners always allowed; members without a
// permissions map keep full access (legacy). Backend is the source of truth —
// this only hides nav and guards routes for a cleaner UX.
export const PAGES = [
  "dashboard", "jobs", "bookings", "customers", "vehicles", "quotes",
  "invoices", "finance", "expenses", "parts", "suppliers", "mot", "team", "settings",
];
export const ACTIONS = ["view", "create", "edit", "delete"];

export const PAGE_LABELS = {
  dashboard: "Dashboard", jobs: "Jobs", bookings: "Bookings", customers: "Customers",
  vehicles: "Vehicles", quotes: "Quotes", invoices: "Invoices", finance: "Finance",
  expenses: "Expenses", parts: "Parts", suppliers: "Suppliers", mot: "MOT History/Lookup",
  team: "Team Management", settings: "Account & Settings",
};

// Route path -> page key (for nav filtering and route guarding).
export const ROUTE_PAGE = {
  "/dashboard": "dashboard", "/jobs": "jobs", "/calendar": "bookings",
  "/money": "finance", "/customers": "customers", "/vehicles": "vehicles",
  "/quotations": "quotes", "/parts": "parts", "/suppliers": "suppliers",
  "/team": "team", "/mot-lookup": "mot", "/more": "settings",
};

export function can(user, page, action = "view") {
  if (!user || user.role === "owner") return true;
  const perms = user.permissions;
  if (!perms) return true; // legacy member — full access until owner sets perms
  if (!page) return true;
  return !!(perms[page] && perms[page][action]);
}

export function emptyPermissions() {
  const o = {};
  PAGES.forEach((p) => { o[p] = { view: false, create: false, edit: false, delete: false }; });
  return o;
}

export function allPermissions() {
  const o = {};
  PAGES.forEach((p) => { o[p] = { view: true, create: true, edit: true, delete: true }; });
  return o;
}

// Optional editable presets (owner can tweak after applying).
export const PRESETS = {
  "Team Member": ["jobs", "bookings", "customers", "vehicles", "parts", "mot"],
  "Front Desk": ["dashboard", "bookings", "customers", "vehicles", "quotes", "invoices", "mot"],
  "Finance Manager": ["dashboard", "invoices", "finance", "expenses", "suppliers"],
  "Full Access": PAGES,
};

export function presetPermissions(pageList, { withDelete = false } = {}) {
  const o = emptyPermissions();
  pageList.forEach((p) => { o[p] = { view: true, create: true, edit: true, delete: withDelete }; });
  return o;
}
